import React from 'react';
import { motion } from 'framer-motion';

const AnimatedTitle = () => {
  return (
    <div className="text-center z-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="mb-4"
      >
        <h2 className="text-2xl text-gray-600 font-cursive">Nos Casamos</h2>
      </motion.div>

      <motion.h1
        className="text-6xl md:text-8xl font-cursive text-gray-800 mb-6"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 1.2,
          delay: 0.3,
          type: "spring",
          stiffness: 100
        }}
      >
        Jime & Pablo
      </motion.h1>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
        className="flex justify-center items-center gap-4"
      >
        <span className="h-[1px] w-16 bg-gray-400"></span>
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >

        </motion.div>
        <span className="h-[1px] w-16 bg-gray-400"></span>
      </motion.div>
    </div>
  );
};

export default AnimatedTitle; 